function ImageTitle() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>An image has a title attribute value but no alt value.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>The title attribute value for images that lack an alt attribute value will be presented to screen reader users. However, providing image content in the alt attribute typically provides better accessibility, and should be used in most cases. The title attribute will generate a mouse hover tooltip which may or may not be desired - this tooltip will not be presented to touch screen or keyboard users.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure the title attribute value presents the content and function of the image. For better accessibility, the alt attribute should be used when possible.</p>
    </blockquote>
  )
}

export default ImageTitle